module.exports = __webpack_public_path__ + "static/media/milk.622735ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/milk.svg
// module id = 1114
// module chunks = 0